import { render, staticRenderFns } from "./modal-cad-lotacao.vue?vue&type=template&id=6c07b2ff"
import script from "./modal-cad-lotacao.vue?vue&type=script&lang=js"
export * from "./modal-cad-lotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports